import React, { createContext, useRef, useState } from "react";
import {DELIVERY_THIRD_PARTY, STORAGE_KEY_COMPLETED_TAB_ROWS_PER_PAGE} from "../helpers/Constants";
import Themes from '../styles/Themes';
import Modes from "./Modes";
import Routes from "./RouteNames";
import { useDebounce } from "use-debounce";
import {getFromStorage} from "../services/LocalStorage";

export const AppContext = createContext();

export function AppContextProvider({ children }) {
    const [currentTheme, setCurrentTheme] = useState(Themes['dark']);
    const [resources, setResources] = useState({});

    const [orders, setOrders] = useState([]);
    const [isInitialOrderLoading, setIsInitialOrderLoading] = useState(true);
    const [pages, setPages] = useState([]);
    const [offset, setOffset] = useState(-1);
    const [kitchen, setKitchen] = useState({ name: "Kitchen Name" });
    const [currentPage, setCurrentPage] = useState(0);

    // This will be set by the dashboard component based on available screen space
    // This is then used by PollingTimer to calculate pages
    const [ordersPerPage, setOrdersPerPage] = useState(0);

    const user_storaged_data = localStorage.getItem('dashboard_user');
    const [authData, setAuth] = useState(user_storaged_data ? JSON.parse(user_storaged_data) : null);
    const [loggedIn, setLoggedIn] = useState(false);
    const [mode, setMode] = useState(Modes.DRIVER_DASHBOARD);
    const [settingsOpen, setSettingsOpen] = useState(false);

    // dispatcher
    const [localSearchText, setLocalSearchText] = useState('');
    const [searchText] = useDebounce(localSearchText, 200);
    const [selectedTab, setSelectedTab] = useState(0);
    const [waitingTime, setWaitingTime] = useState(16);
    const [completedOrders, setCompletedOrders] = useState([]);
    const [overTimeOrderCount, setOverTimeOrderCount] = useState(0);

    const [scrollContainer, setScrollContainer] = useState(useRef(null));
    const [isAssignerMode, setIsAssignerMode] =  useState(false);
    const [backupAreaId, setBackupAreaId] =  useState(null);
    const [cubbyProcessOrder, setCubbyProcessOrder] = useState(null);
    const [cubbyProcessSuccessOrder, setCubbyProcessSuccessOrder] = useState(null);

    const [defaultDeliveryMode, setDefaultDeliveryMode] = useState(DELIVERY_THIRD_PARTY);
    const [availableDeliveryModes, setAvailableDeliveryModes] = useState([]);

    const [deliveryToggleDialogOpen, setDeliveryToggleDialogOpen] = useState(false);
    const [activeDeliveryToggleOrder, setActiveDeliveryToggleOrder] = useState('');
    const [currentRouteName, setCurrentRouteName] = useState(Routes.DRIVER_DASHBOARD);

    const [isCanceledHistoryDialogOpen, setIsCanceledHistoryDialogOpen] = useState(false)
    const [selectedOrder, setSelectedOrder] = useState(null)
    const [available3plPartners, setAvailable3plPartners] = useState([])

    const [completedTabCurrentPage, setCompletedTabCurrentPage] = useState(1);
    const [completedTabPageSize, setCompletedTabPageSize] = useState(getFromStorage(STORAGE_KEY_COMPLETED_TAB_ROWS_PER_PAGE) ?? 10);

    return (
      <AppContext.Provider
        value={{
          currentTheme,
          setCurrentTheme,
          orders,
          setOrders,
          isInitialOrderLoading,
          setIsInitialOrderLoading,
          offset,
          setOffset,
          kitchen,
          setKitchen,
          authData,
          setAuth,
          loggedIn,
          setLoggedIn,
          mode,
          setMode,
          settingsOpen,
          setSettingsOpen,
          resources,
          setResources,
          // dashboard
          pages,
          setPages,
          ordersPerPage,
          setOrdersPerPage,
          currentPage,
          setCurrentPage,
          // dispatcher
          searchText,
          localSearchText,
          setLocalSearchText,
          selectedTab,
          setSelectedTab,
          waitingTime,
          setWaitingTime,
          completedOrders,
          setCompletedOrders,
          overTimeOrderCount,
          setOverTimeOrderCount,
          scrollContainer,
          setScrollContainer,
          isAssignerMode,
          setIsAssignerMode,
          backupAreaId,
          setBackupAreaId,
          cubbyProcessOrder,
          setCubbyProcessOrder,
          cubbyProcessSuccessOrder,
          setCubbyProcessSuccessOrder,
          defaultDeliveryMode,
          setDefaultDeliveryMode,
          availableDeliveryModes,
          setAvailableDeliveryModes,
          deliveryToggleDialogOpen,
          setDeliveryToggleDialogOpen,
          activeDeliveryToggleOrder,
          setActiveDeliveryToggleOrder,
          currentRouteName,
          setCurrentRouteName,
          isCanceledHistoryDialogOpen,
          setIsCanceledHistoryDialogOpen,
          selectedOrder,
          setSelectedOrder,
          available3plPartners,
          setAvailable3plPartners,
          completedTabCurrentPage,
          setCompletedTabCurrentPage,
          completedTabPageSize,
          setCompletedTabPageSize
        }}
      >
        {children}
      </AppContext.Provider>
    );
  }
